import routes from '@modules/subproperty-settings/subproperty-settings-routes';

export default {
  routes,
};
